import { render, staticRenderFns } from "./subwayrunner.vue?vue&type=template&id=3b8f8524&scoped=true"
import script from "./subwayrunner.vue?vue&type=script&lang=js"
export * from "./subwayrunner.vue?vue&type=script&lang=js"
import style0 from "./subwayrunner.vue?vue&type=style&index=0&id=3b8f8524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f8524",
  null
  
)

export default component.exports